import { Injectable } from '@angular/core';
import { TramApiService } from '../tram-api.service';
import { Schedule, StopSchedule, StopCommonSchedule } from '../core/schedule';
import { LeafletStop } from '../core/stop';
import { Route } from '../core/route';
import { Tram } from '../core/tram';

@Injectable()
export class ScheduleCollector {
    private _schedules: Map<string, Schedule>;
    get schedules() {
        let internalSchedules: Schedule[] = [];
        this._schedules.forEach(s => internalSchedules.push(s));
        return internalSchedules;
    }

    constructor(private api: TramApiService) {
        this._schedules = new Map<string, Schedule>();
    }

    init() {
        this._schedules.clear();

        return this.api.getSchedules(0, 0)
            .then(schedules => {
                schedules.forEach(s => {
                    this._schedules.set(s.id, s);
                });

                return this.schedules;
            });
    }

    get(route: Route, isReverse: boolean): StopSchedule[];
    get(tram: Tram): Promise<Schedule>;
    get(...objects): any {
        if (objects[0] instanceof Route) {
            console.log('objects is Route')
            console.log(objects)
            let route = objects[0] as Route;
            let isReverse = objects[1];
            let internalSchedules: StopSchedule[] = [];
            this.schedules.some(s => {
                if (s.routeId === route.id && s.isReverseTrip === isReverse) {
                    internalSchedules = s.stopSchedules;
                    return true;
                }

                return false;
            })

            return internalSchedules;
        } else if (objects[0] instanceof Tram) {
            console.log('objects is Tram')
            console.log(objects)
            let tram = objects[0];
            return tram.scheduleId
                ? this.api.getSchedule(tram.scheduleId)
                : Promise.reject(null);
        }
    }

    getScheduleByStopAndRoute(stopId: number, routeId: number): Promise<StopCommonSchedule> {
        return this.api.getStopSchedule(stopId, routeId, 0, 0);
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/schedule-collector.ts